import { get, writable } from 'svelte/store';
import { CustomerService } from '../../services/customer.service';
export const loading = writable(false);
export const records = writable([]);
export const record = writable(null);
export async function initList(customerId) {
    record.set(null);
    await load(customerId);
}
export async function load(customerId) {
    loading.set(true);
    try {
        let _resp = await CustomerService.getCustomerCod317(customerId);
        records.set(_resp.payload);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate(customerId) {
    record.set({
        oid: 0,
        customerId: customerId,
        cod317: ''
    });
}
export function onEdit(item) {
    record.set(item);
}
export async function save() {
    let _record = get(record);
    return await CustomerService.saveCustomerCod317(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await CustomerService.deleteCustomerCod317(item.oid);
    await load(item.customerId);
}
